<template>
  <b-row v-if="profiles.length" class="mb-4">
    <b-col cols="12" offset-sm="1" sm="3">
      <label class="mb-0 mt-2" for="project-design-profile">{{ $t('settings.project.designProfile.label') }}</label>
    </b-col>
    <b-col cols="12" sm="7">
      <b-form-select id="project-design-profile" v-model="choice" :options="options" @change="save" />
      <b-form-text :class="{ 'text-danger': error }">
        {{ $t(error ? 'settings.project.designProfile.error' : saved ? 'settings.project.designProfile.saved' : 'settings.project.designProfile.help') }}
      </b-form-text>
    </b-col>
  </b-row>
</template>

<script>
import GetProjectDesignProfile from '@/graphQlQueries/queries/getProjectDesignProfile';
import GetDesignProfiles from '@/graphQlQueries/queries/getDesignProfiles';
import SetProjectDesignProfile from '@/graphQlQueries/mutations/setProjectDesignProfile';

/** The project's design profile (spec 2026-10-13 step 2 part B); shown only when its account has profiles. */
export default {
  name: 'ProjectDesignProfile',
  props: {
    projectId: { type: Number, required: true },
  },
  data() {
    return {
      profiles: [], savedId: null, choice: null, saved: false, error: false,
    };
  },
  computed: {
    // A profile of another account (the project was moved) counts as the default, like the server.
    selected() {
      return this.profiles.some((p) => p.profile_id === this.savedId) ? this.savedId : null;
    },
    options() {
      const standard = this.profiles.find((p) => p.is_default);
      const name = standard ? standard.name : this.$t('settings.project.designProfile.neutral');
      return [
        { value: null, text: this.$t('settings.project.designProfile.default', { name }) },
        ...this.profiles.map((p) => ({ value: p.profile_id, text: p.name })),
      ];
    },
  },
  watch: {
    projectId: 'load',
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const { data } = await this.$apollo.query({ query: GetProjectDesignProfile, variables: { projectId: this.projectId }, fetchPolicy: 'network-only' });
      const project = data.projects_by_pk;
      if (!project) return;
      const list = await this.$apollo.query({ query: GetDesignProfiles, variables: { groupId: project.group_id }, fetchPolicy: 'network-only' });
      this.profiles = list.data.design_profiles || [];
      this.savedId = project.design_profile_id;
      this.choice = this.selected;
    },
    async save(id) {
      this.saved = false;
      this.error = false;
      try {
        await this.$apollo.mutate({ mutation: SetProjectDesignProfile, variables: { projectId: this.projectId, id } });
      } catch (err) {
        console.error('[ProjectDesignProfile]', err);
        this.error = true;
        // The select shows what is stored again, not the choice that failed.
        this.choice = this.selected;
        return;
      }
      this.savedId = id;
      this.saved = true;
    },
  },
};
</script>
